package com.essntl.features.paymentparameter.ui.paymentparameter

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.collectSuccessEvent
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class PaymentParameterViewModel(
    private val paymentParameterRepository: PaymentParameterRepository,
    private val state: MutableStateFlow<PaymentParameterState>,
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getCurrentProfile()

        // Get Current User Use Case
        collectSuccessEvent(
            flow = getCurrentUserUseCase.successEvent,
            getState = { state.value.getProfile },
            setState = { newState -> state.update { it.copy(getProfile = newState) } },
        )
    }

    fun onEvent(event: PaymentParameterEvent) {
        when (event) {
            is PaymentParameterEvent.GetPaymentParameters -> getPaymentParameters()
            is PaymentParameterEvent.AddPaymentParameter -> addPaymentParameter(event)
            is PaymentParameterEvent.EditPaymentParameter -> editPaymentParameter(event)
            is PaymentParameterEvent.DeletePaymentParameter -> deletePaymentParameter(event)
        }
    }

    private fun getCurrentProfile() =
        scope.launch {
            getCurrentUserUseCase.get()
        }

    private fun getPaymentParameters() =
        getData(
            getData = { paymentParameterRepository.getAll() },
            getState = { state.value.getAllPaymentParameter },
            setState = { newState -> state.update { it.copy(getAllPaymentParameter = newState) } },
        )

    private fun addPaymentParameter(event: PaymentParameterEvent.AddPaymentParameter) =
        state.update {
            it.copy(
                getAllPaymentParameter = it.getAllPaymentParameter.copy(
                    data = it.getAllPaymentParameter.data.orEmpty() + event.p,
                ),
            )
        }

    private fun editPaymentParameter(event: PaymentParameterEvent.EditPaymentParameter) =
        state.update {
            it.copy(
                getAllPaymentParameter = it.getAllPaymentParameter.copy(
                    data = it.getAllPaymentParameter.data
                        .orEmpty()
                        .map { pp ->
                            if (pp.id == event.p.id) event.p else pp
                        },
                ),
            )
        }

    private fun deletePaymentParameter(event: PaymentParameterEvent.DeletePaymentParameter) {
        if (state.value.deleteLoading.contains(event.p.id)) return

        state.value = state.value.copy(
            deleteLoading = state.value.deleteLoading + event.p.id,
        )

        scope.launch {
            paymentParameterRepository.delete(event.p)
                .onSuccess {
                    state.update {
                        it.copy(
                            getAllPaymentParameter = it.getAllPaymentParameter.copy(
                                data = it.getAllPaymentParameter.data
                                    .orEmpty()
                                    .filter { pp -> pp.id != event.p.id },
                            ),
                            deleteLoading = it.deleteLoading - event.p.id,
                        )
                    }
                }
                .onFailure {
                    state.value = state.value.copy(
                        deleteLoading = state.value.deleteLoading - event.p.id,
                    )
                }
        }
    }
}